import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../../../Translator';
import { Select } from '../../../Select';
import Popover from '../../../Popover';
import Button from '../../../Button';
import styles from './ListSidebarOptions.module.css';

const bindClasses = classNameBind.bind(styles);

const ListSidebarOptions = ({
  sortItems,
  sortDefault,
  onSortByItemSelected,
  filtersPopoverElement,
  filtersPopoverProps,
  isFilterActive,
  bulkSelection,
  bulkSelectionMode,
  onBulkSelectionModeChange,
}) => (
  <div
    className={bindClasses('wrapper')}
    data-ppuc-id="ListSidebar.ListSidebarOptions"
  >
    {(sortItems && onSortByItemSelected)
      ? (
        <div className={bindClasses('selector')}>
          <div className={bindClasses('sortSelect')}>
            <Select
              name="ListSidebar.ListSidebarOptions.Sort"
              options={sortItems}
              value={sortDefault}
              onChange={(event) => { onSortByItemSelected(event.target.value); }}
              type="subduedCompactSmall"
              alternativeIcon={{
                icon: 'sort',
              }}
              hideArrowDownIcon
              dataId="sort-select"
            />
          </div>
        </div>
      )
      : <div className={bindClasses('spacer')} />
    }
    {filtersPopoverElement
      ? (
        <Popover
          position="bottom"
          activatorElement={
            (
              <div className={bindClasses('filtersButton')}>
                <Button
                  appearance={isFilterActive ? 'primary' : 'subdued-compact'}
                  icon="filter"
                  dataId="filters-button"
                />
              </div>
            )
          }
          subdued={false}
          speechBubble
          hoverTrigger={false}
          noPadding
          {...filtersPopoverProps}
        >
          {filtersPopoverElement}
        </Popover>
      ) : null
    }
    {bulkSelection
      && (
        <div className={bindClasses('filtersButton')}>
          <Button
            icon="edit"
            appearance={bulkSelectionMode ? 'simple' : 'subdued-compact'}
            onClick={onBulkSelectionModeChange}
            dataId="bulk-selection-button"
          />
        </div>
      )
    }
  </div>
);

ListSidebarOptions.defaultProps = {
  sortItems: null,
  sortDefault: null,
  onSortByItemSelected: () => {},
  filtersPopoverElement: null,
  filtersPopoverProps: {},
  isFilterActive: false,
  bulkSelection: false,
  bulkSelectionMode: false,
  onBulkSelectionModeChange: () => {},
};

export const PureComponent = ListSidebarOptions;
export default withTranslation('components')(ListSidebarOptions);
